// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import permission from './directive/permission'
import style from './directive/style'
import store from './store/'
import i18n from './locales'
import {
	VueAxios
} from './utils/request'
import ProLayout, {
	PageHeaderWrapper
} from '@/components/ProLayout'
import FooterToolBar from '@/components/FooterToolbar'
import FileUpload from '@/components/FileUpload'
import themePluginConfig from '../config/themePluginConfig'
import {
	TableSetting
} from '@/components'
// 字典数据组件
import DictData from '@/components/DictData'
// 字典标签组件
import DictTag from '@/components/DictTag'

import {
	Cascader
} from 'ant-design-vue'
// 引入组件样式（局部注册必须手动引入）
import 'ant-design-vue/lib/cascader/style/css'

import bootstrap from './core/bootstrap'
import './core/lazy_use' // use lazy load components
import './permission' // permission control
import './utils/filter' // global filter
import publicFunc from '@/assets/js/public.js' // global filter
import '@/assets/css/pingfang.css' // 本地苹方字体
import './global.less' // global style
import '@/assets/css/form-control-text.less' // 表单内容与提示语字号统一
import '@/assets/css/button-tokens.less' // 列表筛选/操作按钮尺寸统一
import '@/assets/css/main.css' // ruoyi css main.css
import baseData from '@/assets/js/baseData.js'; // 公共数据
import {
	getDicts
} from '@/api/system/dict/data'
import {
	getConfigKey
} from '@/api/system/config'
import {
	parseTime,
	resetForm,
	addDateRange,
	selectDictLabel,
	selectDictLabels,
	handleTree,
	tableSorter
} from '@/utils/ruoyi'
import {
	download
} from '@/utils/request'
import { normalizeResourceUrl } from '@/utils/resourceUrl'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'

import themeColor from '@/components/SettingDrawer/themeColor.js'
Vue.prototype.$theme = themeColor
themeColor.initTheme()

import moment from 'moment'
// 2. 引入中文语言包
import 'moment/locale/zh-cn';
// 3. 全局挂载到 Vue 原型（所有组件可通过 this.$moment 使用）
// 4. 设置全局语言为中文（可选，推荐）

import websocket from '@/utils/socket';


Vue.use(VueDirectiveImagePreviewer, {
	zIndex: '2019'
})

Vue.prototype.$ws = websocket;

// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.tableSorter = tableSorter
Vue.prototype.$resourceUrl = normalizeResourceUrl
Vue.prototype.$moment = moment;
moment.locale('zh-cn');
for (let key in publicFunc) {
	Vue.prototype[key] = publicFunc[key];
}

for (let key in baseData) {
	Vue.prototype[key] = baseData[key];
}

Vue.config.productionTip = false

// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
// use pro-layout components
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)
Vue.component('footer-tool-bar', FooterToolBar)
Vue.component('file-upload', FileUpload)
Vue.component('table-setting', TableSetting)
Vue.component('dict-tag', DictTag)
Vue.component('a-cascader', Cascader)


Vue.use(permission)
Vue.use(style)
DictData.install()

window.umi_plugin_ant_themeVar = themePluginConfig.theme

router.afterEach((to) => {
  // 非登录页且未连接时，初始化Socket
  // if (to.path !== '/login' && !socketApi.connected) {
  //   // this.$websocket.initWebSocket()
  // }
});

import { Message } from 'ant-design-vue'
import 'ant-design-vue/lib/message/style/css'
Vue.prototype.$message = Message

// vxe-table（Vue2）：大数据列表虚拟滚动
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)

new Vue({
	router,
	store,
	i18n,
	// init localstorage, vuex
	created: bootstrap,
	render: h => h(App)
}).$mount('#app')